import React from 'react';
import { Bar, Pie, Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale, LinearScale, BarElement, ArcElement, PointElement, LineElement, Tooltip, Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, ArcElement, PointElement, LineElement, Tooltip, Legend);

export default function ChartComponent({ chart }) {
    const data = {
        labels: chart.labels,
        datasets: [{
            label: chart.title || "Chart",
            data: chart.data,
            backgroundColor: 'rgba(75,192,192,0.4)',
        }]
    };

    const options = { responsive: true, plugins: { legend: { position: 'top' } } };

    if (chart.type === 'pie') return <Pie data={data} options={options} />;
    if (chart.type === 'line') return <Line data={data} options={options} />;
    return <Bar data={data} options={options} />;
}
